import * as React from "react";
import { Dropdown } from "semantic-ui-react";

import { DropdownAnchor } from ".";

const PrivacyAndCookiesMenu: React.FunctionComponent = () => (
    <Dropdown inline item upward className="cookies-dropdown" text="Privacy &amp; Cookies">
        <Dropdown.Menu>
            <DropdownAnchor href="https://www.optimahealth.co.uk/privacy-policy">Privacy Policy</DropdownAnchor>
            <DropdownAnchor href="/api/cookiesPolicy">Cookies Policy</DropdownAnchor>
        </Dropdown.Menu>
    </Dropdown>
);

export { PrivacyAndCookiesMenu };
